import React from 'react'
import { useNavigate } from 'react-router-dom'
import { getThemeColors, THEME_OPTIONS } from '../theme'
import Header from './Header'
import Footer from './Footer'

const TERMS_VERSION = '2026-04-19'

export default function Terminos({ theme = THEME_OPTIONS.LIGHT, session = null }) {
  const C = getThemeColors(theme)
  const navigate = useNavigate()
  const search = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null
  const fromBetaAccess = search?.get('from') === 'beta-access'
  const fromRegister = search?.get('from') === 'register'

  const sectionStyle = {
    background: C.white,
    border: `0.5px solid ${C.border}`,
    borderRadius: '18px',
    padding: '24px',
    boxShadow: C.shadow,
  }

  return (
    <div style={{ minHeight: '100vh', background: C.bg, color: C.text, fontFamily: "'DM Sans', system-ui, sans-serif" }}>
      <Header theme={theme} session={session} perfil={null} />

      <div style={{ maxWidth: '1080px', margin: '0 auto', padding: 'clamp(16px, 3vw, 32px)', boxSizing: 'border-box' }}>
        <div style={{ ...sectionStyle, marginBottom: '18px' }}>
          <div style={{ fontSize: '11px', color: C.blue, textTransform: 'uppercase', letterSpacing: '0.1em', fontWeight: '600', marginBottom: '8px' }}>Términos</div>
          <div style={{ fontSize: '34px', fontWeight: '500', letterSpacing: '-1px', lineHeight: '1.1', marginBottom: '10px' }}>Términos y Condiciones de JobPipeline</div>
          <div style={{ fontSize: '13px', color: C.muted, lineHeight: '1.8' }}>Última actualización: {TERMS_VERSION}</div>
        </div>

        <div style={{ display: 'grid', gap: '18px' }}>
          {[
            ['1. Objeto del servicio', 'JobPipeline es una plataforma digital orientada a apoyar la búsqueda de empleo mediante automatización, filtrado, análisis, priorización y visualización de oportunidades laborales conforme al perfil y preferencias del usuario.'],
            ['2. Beta controlada', 'El servicio puede operar en modalidad beta. Durante esta etapa, ciertas funciones pueden estar incompletas, modificarse, suspenderse o presentar errores. El acceso a la beta puede limitarse, revocarse o pausarse en cualquier momento.'],
            ['3. Sin garantía de empleo', 'JobPipeline no garantiza entrevistas, respuestas, contrataciones ni resultados específicos. La plataforma ayuda a organizar y priorizar oportunidades, pero la decisión de aplicar o continuar corresponde al usuario.'],
            ['4. Responsabilidad del usuario', 'El usuario debe proporcionar información veraz, revisar las vacantes antes de aplicar, custodiar sus credenciales y usar la plataforma de forma lícita y de buena fe.'],
            ['5. Uso no permitido', 'No se permite usar la plataforma con fines ilícitos, interferir con su operación, acceder sin autorización a sistemas o datos, ni copiar, revender o explotar el servicio sin autorización.'],
            ['6. Contenido del usuario', 'El usuario conserva la titularidad sobre su información, incluyendo CV y preferencias, y autoriza a JobPipeline a usarla de forma limitada para operar, mejorar y prestar el servicio.'],
            ['7. Contenido de terceros', 'Las vacantes y descripciones pueden provenir de fuentes de terceros. JobPipeline no garantiza que toda la información externa sea exacta, completa o vigente en todo momento.'],
            ['8. Disponibilidad y cambios', 'JobPipeline puede modificar, restringir, suspender o descontinuar funciones, total o parcialmente, especialmente durante la etapa beta.'],
            ['9. Feedback', 'Si el usuario comparte comentarios, ideas o sugerencias, JobPipeline podrá utilizarlos para mejorar el servicio sin obligación de compensación.'],
            ['10. Privacidad', 'El tratamiento de datos personales se rige por el Aviso de Privacidad de JobPipeline.'],
            ['11. Suspensión o cancelación', 'JobPipeline podrá suspender o cancelar cuentas cuando detecte incumplimientos, riesgos de seguridad, uso indebido, abuso de la beta o conductas que afecten la operación del servicio.'],
            ['12. Limitación de responsabilidad', 'En la medida permitida por la ley aplicable, JobPipeline no será responsable por daños indirectos, incidentales, pérdida de oportunidades, pérdida de datos, interrupciones del servicio o decisiones tomadas por el usuario con base en la información presentada por la plataforma.'],
            ['13. Modificaciones a estos términos', 'JobPipeline podrá actualizar estos términos. Cuando el cambio sea relevante, podrá solicitarse una nueva aceptación antes de continuar usando la plataforma.'],
            ['14. Ley aplicable', 'Estos términos se interpretarán conforme a las leyes aplicables de México, salvo disposición obligatoria distinta que resulte aplicable.'],
          ].map(([title, text]) => (
            <div key={title} style={sectionStyle}>
              <div style={{ fontSize: '20px', fontWeight: '500', marginBottom: '10px' }}>{title}</div>
              <div style={{ fontSize: '14px', color: C.muted, lineHeight: '1.9' }}>{text}</div>
            </div>
          ))}
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', marginTop: '24px' }}>
          <button onClick={() => navigate(fromBetaAccess ? '/beta-access' : fromRegister ? '/login?mode=register' : (session ? '/dashboard' : '/'))} style={{ fontSize: '12px', color: C.blue, background: 'none', border: 'none', cursor: 'pointer' }}>
            {fromBetaAccess ? 'Volver a acceso beta' : fromRegister ? 'Volver al registro' : session ? 'Volver al dashboard' : 'Volver al inicio'}
          </button>
          <button onClick={() => navigate('/privacidad')} style={{ fontSize: '12px', color: C.muted, background: 'none', border: 'none', cursor: 'pointer' }}>
            Aviso de Privacidad
          </button>
        </div>

        <Footer theme={theme} />
      </div>
    </div>
  )
}

